export const formatEmail = (email: string) => {
    const [localPart, domain] = email.split('@');
    const formattedLocalPart =
        localPart.length > 1 ? localPart.charAt(0) + '*'.repeat(5) : localPart;
    return `${formattedLocalPart}@${domain}`;
};
